export default __webpack_public_path__ + "c8ada0606be0cf3ec11e8384a74869cc.webp";